<div class="main">
  <div class="text-center">
    <img src="assets/image/success-icon.svg" />
  </div>
  <div class="mt-3 text-center">
    <h2 *ngIf="personType == 'pj'">Cadastro realizado!</h2>
    <h2 *ngIf="personType == 'pf'">Cadastro enviado!</h2>
    <p *ngIf="personType == 'pj'" class="mt-3 mb-5">Verifique seu e-mail e faça login para começar a enviar e receber dinheiro
      de maneira 100% digital</p>
      <p *ngIf="personType == 'pf'" class="mt-3 mb-5">Em instantes enviaremos um link de confirmação para o e-mail cadastrado. Após confirmado, basta logar no nosso sistema.</p>   
  </div>
  <div>
    <button *ngIf="personType == 'pj'" class="button-pj btn btn-block mt-3" type="button" (click)="goToLogin()">
      Fazer login
    </button>
    <button *ngIf="personType == 'pf'" class="button-pf btn btn-block mt-3" type="button" (click)="goToLogin()">
      Fazer login
    </button>
  </div>
</div>
